import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { APP_CONFIG } from '@/app/core/config/app-config.token';
import { ShellStore } from './shell.store';

@Component({
  selector: 'app-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <header class="shell-header">
      <button
        class="sidebar-toggle"
        (click)="store.toggleSidebar()"
        title="Alternar menú"
        aria-label="Alternar menú lateral"
      >
        <span class="toggle-bar"></span>
        <span class="toggle-bar"></span>
        <span class="toggle-bar"></span>
      </button>

      <div class="header-brand">
        <!-- Logo ISAPRE Colmena (panal) — descomenta para reemplazar por logo corporativo de la isapre:
        <span class="brand-mark" aria-hidden="true">
          <svg viewBox="1 0 32 32" xmlns="http://www.w3.org/2000/svg" width="28" height="28">
            <polygon points="17,0 24.8,4.5 24.8,13.5 17,18 9.2,13.5 9.2,4.5"
                     fill="#0078C8" stroke="white" stroke-width="1.2" stroke-linejoin="round"/>
            <polygon points="9.2,13.5 17,18 17,27 9.2,31.5 1.4,27 1.4,18"
                     fill="#0078C8" stroke="white" stroke-width="1.2" stroke-linejoin="round"/>
            <polygon points="24.8,13.5 32.6,18 32.6,27 24.8,31.5 17,27 17,18"
                     fill="#0078C8" stroke="white" stroke-width="1.2" stroke-linejoin="round"/>
          </svg>
        </span>
        -->
        <img
          src="https://portal.colmenaseguros.cl/images/LogoSimpleColor.png"
          alt="Colmena"
          class="brand-logo"
        />
        <span class="brand-name">Prueba Flujo Nitro</span>

        @if (env !== 'prod') {
          <span class="brand-badge" [attr.data-env]="env">{{ env }}</span>
        }
      </div>

      <div class="header-spacer"></div>

      <div class="user-chip">
        <span class="user-avatar">US</span>
        <span class="user-name">Usuario</span>
      </div>
      <button class="btn-logout" (click)="logout()">Salir</button>
    </header>
  `,
  styles: [
    `
      :host {
        display: block;
        grid-area: header;
        min-width: 0;
      }

      .shell-header {
        grid-area: header;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0 1.5rem;
        background: var(--surface);
        border-bottom: 1px solid var(--border);
        height: var(--header-h);
        position: sticky;
        top: 0;
        z-index: 100;
        box-shadow: var(--shadow-sm);
      }

      .sidebar-toggle {
        background: none;
        border: none;
        color: var(--muted);
        cursor: pointer;
        padding: 0.5rem;
        border-radius: var(--radius-xs);
        display: flex;
        flex-direction: column;
        gap: 5px;
        transition: background 120ms;
      }
      .sidebar-toggle:hover {
        color: var(--primary);
        background: var(--surface-2);
      }
      .toggle-bar {
        display: block;
        width: 20px;
        height: 2px;
        background: currentColor;
        border-radius: 2px;
        transition: background 120ms;
      }

      .header-brand {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
      .brand-logo {
        height: 32px;
        width: auto;
        object-fit: contain;
        flex-shrink: 0;
      }
      .brand-name {
        font-weight: 700;
        font-size: 1rem;
        color: var(--primary);
        letter-spacing: -0.01em;
      }
      .brand-badge {
        font-size: 0.65rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        padding: 0.15rem 0.55rem;
        border-radius: 999px;
        border: 1px solid transparent;
        /* development (default) */
        color: var(--primary);
        background: var(--primary-subtle);
        border-color: rgba(0, 120, 200, 0.2);
      }
      .brand-badge[data-env='qa'] {
        color: var(--success);
        background: var(--success-subtle);
        border-color: rgba(45, 125, 50, 0.2);
      }
      .brand-badge[data-env='uat'] {
        color: var(--warning);
        background: var(--warning-subtle);
        border-color: rgba(230, 92, 0, 0.2);
      }

      .header-spacer {
        flex: 1;
      }

      .user-chip {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.25rem 0.875rem 0.25rem 0.25rem;
        background: var(--surface-2);
        border-radius: 999px;
        border: 1px solid var(--border);
      }
      .user-avatar {
        width: 2rem;
        height: 2rem;
        background: var(--primary);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.8125rem;
        font-weight: 700;
        color: #fff;
      }
      .user-name {
        font-size: 0.875rem;
        font-weight: 500;
        color: var(--text);
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .btn-logout {
        background: none;
        border: 1px solid var(--border);
        color: var(--muted);
        font-size: 0.875rem;
        cursor: pointer;
        padding: 0.4rem 1rem;
        border-radius: 999px;
        transition:
          color 150ms,
          border-color 150ms,
          background 150ms;
      }
      .btn-logout:hover {
        color: var(--danger);
        border-color: var(--danger);
        background: var(--danger-subtle);
      }
    `,
  ],
})
export class HeaderComponent {
  protected readonly store = inject(ShellStore);
  protected readonly env = inject(APP_CONFIG).environment;

  protected logout(): void {}
}
